// client/components/Inventar/InventarStatusBadge.jsx
import React from "react";
import { INVENTAR_STATUS_OPTIONS } from "../../constants/inventarStatus";

const MAP_DARK = {
  verfügbar: {
    bg: "bg-green-500/15",
    border: "border-green-400/25",
    text: "text-green-300",
  },
  ausgeliehen: {
    bg: "bg-amber-500/15",
    border: "border-amber-400/25",
    text: "text-amber-300",
  },
  in_reparatur: {
    bg: "bg-blue-500/15",
    border: "border-blue-400/25",
    text: "text-blue-300",
  },
  vergeben: {
    bg: "bg-purple-500/15",
    border: "border-purple-400/25",
    text: "text-purple-300",
  },
  verbraucht: {
    bg: "bg-slate-500/15",
    border: "border-slate-400/25",
    text: "text-slate-300",
  },
};

const labelByValue = Object.fromEntries(INVENTAR_STATUS_OPTIONS.map((o) => [o.value, o.label]));

export default function InventarStatusBadge({ status, small = false }) {
  const key = status || "verfügbar";
  const s = MAP_DARK[key] || MAP_DARK.verfügbar;
  const label = labelByValue[key] || key;
  return (
    <span
      className={[
        "rounded-full border whitespace-nowrap",
        small ? "px-1.5 py-0 text-[9px] leading-4" : "px-2 py-0.5 text-[11px]",
        s.bg,
        s.border,
        s.text,
      ].join(" ")}
    >
      {label}
    </span>
  );
}
